import { Unit } from "../../../types/DrawingItem";
import { drawingStore } from "../store";

export const setUnitPreference = (unitPreference: Unit) => {
  const actions = drawingStore.reduxStore?.actions;
  const store = drawingStore.reduxStore?.store;
  if (!store || !actions) return;

  store.dispatch(actions.setUnitPreference(unitPreference));
};
